import { Fragment, useEffect, useRef, useState } from "react";

import PhotoScalePopover from "@/appComponents/Blocks/Composites/PhotoScalePopover/PhotoScalePopover";
import { BackgroundContextMenu } from "@/appComponents/Blocks/Menus/BackgroundContextMenu/BackgroundContextMenu";
import { CanvasContextMenu } from "@/appComponents/Blocks/Menus/CanvasContextMenu/CanvasContextMenu";
import { LayoutHoverToolbar } from "@/appComponents/Blocks/Composites/LayoutHoverToolbar/LayoutHoverToolbar";
import { BoxCellContextMenu } from "@/appComponents/Blocks/Menus/BoxCellContextMenu/BoxCellContextMenu";
import { SubscribeExternalModuleReactAPI } from "@coreapp/main";

const ContextMenuProvider = ({ children }) => {
  const floatingCtrlCanvasRef = useRef(null);
  const openCtrlCanvasRef = useRef(null);

  const floatingCtrlPhotoRef = useRef(null);
  const openCtrlPhotoRef = useRef(null);

  const floatingCtrlBoxCellRef = useRef(null);
  const openCtrlBoxCellRef = useRef(null);

  const floatingCtrlBGRef = useRef(null);
  const openCtrlBGRef = useRef(null);

  const floatingCtrlBLEToolbarRef = useRef(null);
  const openCtrlBLEToolbarRef = useRef(null);

  const [targetBox, setTargetBox] = useState(null);
  const [targetCell, setTargetCell] = useState(null);
  const [subType, setSubType] = useState(null);

  const managers = {
    canvas: [floatingCtrlCanvasRef, openCtrlCanvasRef],
    cell: [floatingCtrlBoxCellRef, openCtrlBoxCellRef],
    background: [floatingCtrlBGRef, openCtrlBGRef],
    photo: [floatingCtrlPhotoRef, openCtrlPhotoRef],
    layouteditor: [floatingCtrlBLEToolbarRef, openCtrlBLEToolbarRef]
  };

  const handleOpen = (menuKey, event, options) => {
    const manager = managers[menuKey];
    if (!manager) {
      console.warn(`Unable to find context menu manager for specified key (${menuKey})`);
      return;
    }

    const [floatingCtrlRef, openCtrlRef] = manager;

    openCtrlRef?.current?.setOpen(true);
    if (event && floatingCtrlRef?.current) floatingCtrlRef.current.setPositionReference(event);

    const selectedBox = options?.box;
    const boxSubType = selectedBox?.GetBoxSubType();

    setTargetBox(selectedBox);
    setTargetCell(options?.cell);
    setSubType(boxSubType);
  };

  useEffect(() => {
    SubscribeExternalModuleReactAPI(handleOpen, "contextMenu");
  }, []);

  return (
    <Fragment>
      <CanvasContextMenu openCtrlRef={openCtrlCanvasRef} floatingCtrlRef={floatingCtrlCanvasRef} />
      <BackgroundContextMenu
        openCtrlRef={openCtrlBGRef}
        floatingCtrlRef={floatingCtrlBGRef}
        targetBox={targetBox}
        subType={subType}
      />
      <PhotoScalePopover
        toolbarPopoverProps={{
          otherPopoverProps: {
            floatingCtrlRef: floatingCtrlPhotoRef,
            openCtrlRef: openCtrlPhotoRef,
            reference: null
          }
        }}
      />
      <LayoutHoverToolbar
        openCtrlRef={openCtrlBLEToolbarRef}
        floatingCtrlRef={floatingCtrlBLEToolbarRef}
        targetBox={targetBox}
        targetCell={targetCell}
      />
      <BoxCellContextMenu
        openCtrlRef={openCtrlBoxCellRef}
        floatingCtrlRef={floatingCtrlBoxCellRef}
        targetBox={targetBox}
        targetCell={targetCell}
        subType={subType}
      />
      {children}
    </Fragment>
  );
};

export default ContextMenuProvider;
